import FullLayout from 'layout/FullLayout';
import { useNavigate } from 'react-router-dom';

const ThankyouPage = () => {
  const navigate = useNavigate();

  return (
    <FullLayout>
      <div className="text-kin-text h-[calc(100vh-254px)] flex items-center justify-center px-4">
        <div className="w-full max-w-xl rounded-2xl border border-gray-200 bg-white p-8 text-center shadow-sm">
          <span className="inline-flex items-center rounded-full bg-primary-main px-3 py-1 text-xs font-semibold text-white">
            PAYMENT SUCCESS
          </span>

          <h1 className="mt-4 text-2xl font-semibold text-gray-900">Your purchase is confirmed!</h1>
          <p className="mt-3 text-sm font-light text-gray-600">
            Your class ticket has been successfully purchased. You can review your pass details and
            ticket information from the My Passes page.
          </p>

          <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <button
              type="button"
              onClick={() => navigate('/my-passes')}
              className="w-full sm:w-auto bg-primary-main text-white rounded-[100px] py-3 px-5 flex justify-center items-center">
              <span className="text-xs font-semibold block">GO TO MY PASSES</span>
            </button>

            <button
              type="button"
              onClick={() => navigate('/')}
              className="w-full sm:w-auto border border-gray-300 text-gray-700 rounded-[100px] py-3 px-5 flex justify-center items-center">
              <span className="text-xs font-semibold block">BACK TO HOME</span>
            </button>
          </div>
        </div>
      </div>
      {/* <div className="w-full h-full relative text-kin-text">
        
        <div className="flex justify-center xl:mt-0 md:mt-16  2xl:px-[130px] xl:px-[40px] md:px-[80px] px-6 relative">
          <div className="absolute 2xl:-top-[80px] 2xl:left-[60px] xl:-top-[40px] xl:-left-[20px] md:-top-[80px] md:left-[0px] -top-[75px] -left-[40px] z-20">
            <div className="w-full h-full">
              <img
                className="xl:h-[180px] lg:h-[250px] md:h-[200px] h-[160px] w-auto"
                src="kin/assest/about-3.png"
                alt="kin-frame"
              />
            </div>
          </div>
          <div className="xl:aspect-w-2 xl:aspect-h-2 md:aspect-w-16 md:aspect-h-6 aspect-w-3 aspect-h-2 w-full h-full rounded-xl overflow-hidden z-10">
            <img
              className="object-cover w-full h-full"
              src="kin/assest/kids1.png"
              alt="kin-model"
            />
          </div>
          <div className="hidden md:block absolute 2xl:-bottom-[50px] 2xl:right-[60px] xl:-bottom-[70px] xl:-right-5 lg:-bottom-[130px] md:-bottom-[80px] md:right-[50px] z-20">
            <div className="w-full h-full">
              <img
                className="h-[180px] lg:h-[180px] md:h-[130px] w-auto"
                src="kin/assest/about-2.png"
                alt="kin-frame"
              />
            </div>
          </div>
          <div className="md:hidden block absolute -bottom-[60px] right-0">
            <div className="w-full h-full">
              <img className="h-[180px] w-auto" src="kin/assest/about-2-mob.png" alt="kin-frame" />
            </div>
          </div>
          <div className="hidden md:block absolute 2xl:-bottom-[50px] 2xl:left-[60px] xl:-bottom-[50px] xl:-left-[20px] xl:top-[auto] md:-top-[50px] md:right-0 -bottom-0 right-0">
            <div className="w-full h-full">
              <img
                className="xl:h-[180px] lg:h-[180px] h-[160px] w-auto"
                src="kin/assest/about-1.png"
                alt="kin-frame"
              />
            </div>
          </div>
        </div>
        <div className="w-full h-full relative flex items-center md:px-[80px] px-6 pb-8">
          <div className=" overflow-hidden">
            <div className="text-left animate__animated animate__fadeInUp xl:pb-0">
              <h1 className="text-left font-bold text-xl text-kin-text max-w-lg leading-[normal] mb-7">
                KiN is short for Kids Nusantara
              </h1>
              <span
                className="font-regular text-kin-text 2xl:max-w-xl xl:max-w-lg block"
                dangerouslySetInnerHTML={{ __html: data }}
              />
              <a href="/contact">
                <button className="mt-4 py-1 px-3.5 bg-secondary-main text-white rounded-3xl text-sm mx-auto">
                  Contact Us
                </button>
              </a>
            </div>
          </div>
        </div>
        <div className="h-[40px] lg:hidden block" />
      </div> */}
    </FullLayout>
  );
};

export default ThankyouPage;
